import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { TagsManagerPublisherDomain } from '../../../../../core/components/tags/manager/TagsManagerWrapper';

const CreatePublisherDomainTag = () => {
  const [visible, setVisible] = useState(false);
  return (
    <React.Fragment>
      <Modal
        visible={visible}
        footer={null}
        onCancel={() => {
          setVisible(false);
        }}
        title={'Create Publisher Domain Tags'}
        width={'70%'}
      >
        <TagsManagerPublisherDomain headerSubmit={false} onCard={false} />
      </Modal>
      <Button
        shape="round"
        type="primary"
        onClick={() => {
          setVisible(!visible);
        }}
      >
        Create Publisher Domain Tags
      </Button>
    </React.Fragment>
  );
};

export default CreatePublisherDomainTag;
